// @flow
import createAction from '../../../../../util/createAction';

export const SELECT_PRODUCT = 'marketplace/search/select-product';

export const selectProduct = createAction(SELECT_PRODUCT);
